export const CHEAP_TICKETS_TAB_AVAILABLE_OPTIONS = [
  1, 2, 3, 4, 5, 6, 7, 10, 14, 30, 60, 90,
];
